/**
 * Spinner to display while a route is loading.
 */
import {StyleSheet} from "aphrodite";

import {View} from "@khanacademy/wonder-blocks-core";
import {CircularSpinner} from "@khanacademy/wonder-blocks-progress-spinner";
import {spacing} from "@khanacademy/wonder-blocks-tokens";

/**
 * Spinner component to display while a page is loading.
 */
export default function FullPageSpinner() {
    return (
        <View style={styles.spinnerWrapper}>
            <CircularSpinner />
        </View>
    );
}

const styles = StyleSheet.create({
    spinnerWrapper: {
        alignItems: "center",
        // Add some padding so that the spinner isn't stuck to the header or footer.
        margin: `${spacing.xxLarge_48}px ${spacing.small_12}px`,
    },
});
